<div *ngIf="progressType === progressTypes.spinner">
  <div class="loader"></div>
  <div class="percentage">{{ uploadPercentage }}%</div>
</div>

<div *ngIf="progressType === progressTypes.progressBar" class="mt-1">
  <p-progressBar [value]="uploadPercentage"></p-progressBar>
</div>
